import ProgressBar from "./ProgressBar.component.jsx";

export default ProgressBar;
